/**
 * Number conversion utility for RTL languages
 * Converts Western numerals to language-specific numerals
 */

// Arabic-Indic digits (used in Arabic)
const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

// Persian-Indic digits (used in Persian/Farsi)
const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

// Western digits
const westernDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

/**
 * Convert Western numerals to Arabic-Indic numerals
 */
export function toArabicNumerals(input: string | number): string {
  const str = input.toString();
  return str.replace(/[0-9]/g, (digit) => arabicDigits[parseInt(digit)]);
}

/**
 * Convert Western numerals to Persian-Indic numerals
 */
export function toPersianNumerals(input: string | number): string {
  const str = input.toString();
  return str.replace(/[0-9]/g, (digit) => persianDigits[parseInt(digit)]);
}

/**
 * Convert numerals based on locale
 */
export function toLocalizedNumerals(input: string | number, locale: string): string {
  const str = input.toString();
  
  switch (locale) {
    case 'ar':
      return toArabicNumerals(str);
    case 'fa':
      return toPersianNumerals(str);
    default:
      return str;
  }
}

/**
 * Extract and convert numbers in a text string
 */
export function localizeNumbersInText(text: string, locale: string): string {
  switch (locale) {
    case 'ar':
      return text.replace(/[0-9]/g, (digit) => arabicDigits[parseInt(digit)]);
    case 'fa':
      return text.replace(/[0-9]/g, (digit) => persianDigits[parseInt(digit)]);
    default:
      return text;
  }
}

/**
 * Hook for easy number conversion in components
 */
export function useLocalizedNumbers() {
  return {
    toArabicNumerals,
    toPersianNumerals,
    toLocalizedNumerals,
    localizeNumbersInText
  };
}